import { useMutation } from '@apollo/client/react';
import { PITCH_BUILDER_INVESTOR_SEARCH_FRAGMENT } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder';
import { PitchDeckSection } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/PitchDeckSection';
import { RequestBuilderFormProps } from '@src/components/sco/Requests/RequestBuilder/FormSections/index';
import { gql } from '@src/lib/gql';
import React from 'react';
export const FundingPitchDeckSection: React.FC<RequestBuilderFormProps> = props => {
  const groupRequest = props.groupRequest;
  const [upsertInvestorSearch, upsertInvestorSearchMutation] = useMutation(gql`
    mutation ($input: UpsertInvestorSearchInput!) {
      upsertInvestorSearch(input: $input) {
        investorSearch {
          ${PITCH_BUILDER_INVESTOR_SEARCH_FRAGMENT}
        }
      }
    }
  `);
  return <PitchDeckSection descriptionText={`Upload your pitch deck or any other document that explains your startup.`} investorSearch={groupRequest.investorSearch} upsertInvestorSearch={upsertInvestorSearch} upsertInvestorSearchMutation={upsertInvestorSearchMutation} />;
};